import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './roxe.svg'


const _withScopeId = n => (_pushScopeId("data-v-0f0d92aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "h4 mt20" }
const _hoisted_3 = { class: "flx mt20" }
const _hoisted_4 = { class: "flx" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "mr10",
  src: _imports_0
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h5" }, "Team Roxe", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.linkto && _ctx.linkto(...args))),
    class: "card"
  }, [
    _createElementVNode("img", {
      class: "r20",
      src: _ctx.imglink
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.data.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", null, [
          _hoisted_6,
          _createElementVNode("div", null, _toDisplayString(_ctx.data.date), 1)
        ])
      ]),
      _createElementVNode("div", null, _toDisplayString(_ctx.data.info), 1)
    ])
  ]))
}